import navigationConfig from "@/configs/navigation.config";
import useUiContext from "@/custolink-hooks/useUiContext";
import type { NavigationTree } from "@/@types/navigation";
import cpAdmNavigationConfig from "@/configs/adm-cp.navigation.config";

export function useNavigation(): { navigationConfig: NavigationTree[] } {
  const a = useUiContext();

  if (a.controlpanelContext) {
    return {
      navigationConfig: cpAdmNavigationConfig,
    };
  }

  if (a.organisationContext) {
    return {
      navigationConfig: navigationConfig,
    };
  }

  return {
    navigationConfig: [],
  };
}
